import React, { useState, useEffect } from 'react';
import { Navbar, Button, Container, Nav, Offcanvas } from 'react-bootstrap';
import { List, Whatsapp, CartFill } from 'react-bootstrap-icons';
import { useCarrito } from '../ventaUnidad/componenetes/CarritoContext';
import CarUni from '../ventaUnidad/componenetes/carUni';
import { useNavigate, useParams, Link } from 'react-router-dom';
import logo from '../../../utils/cr1-logo.png';
import { useTiendaConfig } from '../../../hooks/useTiendaConfig';
import getIcon from '../../../utils/getIcon';
import { useSucursal } from '../../../contexts/SucursalContext';

function NavbarUni() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [cartBounce, setCartBounce] = useState(false);
    const [show, setShow] = useState(false);
    const { socialLinks, whatsappLink } = useTiendaConfig();
    const { carrito } = useCarrito();

    const closeCar = () => setShow(false);
    const showCar = () => setShow(true);
    const totalItems = carrito.reduce((total, item) => total + item.quantity, 0);
    const navigate = useNavigate();
    //Sucursal Provider
    const { idSucursal: contextIdSucursal } = useSucursal(); // Obtén el idSucursal del contexto
    const { idSucursal: paramIdSucursal } = useParams();

    // Usa el idSucursal de los parámetros de la URL o, como respaldo, el del contexto
    const idSucursal = paramIdSucursal || contextIdSucursal;

    // Si aún no hay un idSucursal válido, redirige a una sucursal predeterminada o muestra un error
    if (!idSucursal) {
        console.warn('No se encontró idSucursal. Redirigiendo a la sucursal predeterminada...');
        navigate('/1'); // Cambia "1" por el idSucursal predeterminado
    }

    const redirectToRoot = () => {
        if (!idSucursal) {
            console.error('No se puede redirigir porque idSucursal es undefined.');
            return;
        }
        navigate(`/${idSucursal}`);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    useEffect(() => {
        if (totalItems > 0) {
            setCartBounce(true);
            setTimeout(() => setCartBounce(false), 500);
        }
    }, [totalItems]);

    // Esta función se asegura de que siempre obtengas una URL válida de WhatsApp
    const getWhatsappUrl = () => {
        // Verifica si whatsappLink existe y tiene una URL válida
        if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
            return whatsappLink.url;
        }
        // Si no se encuentra un enlace válido, devuelve un fallback
        return '#'; // O un valor predeterminado que prefieras
    };
    //console.log('🔗 Enlace de WhatsApp:', getWhatsappUrl());

    const isActive = (path) => {
        const currentPath = window.location.pathname; // Obtén la ruta actual
        if (path === `/${idSucursal}` || (idSucursal === undefined && currentPath === '/')) {
            // Resaltar "Catálogo" para la URL base, cualquier categoría de productos o el directorio raíz "/"
            return currentPath === path || currentPath === '/' || currentPath.startsWith(`/${idSucursal}/Productos`);
        }
        // Resaltar "Sobre Nosotros" para esa URL específica
        if (path === `/${idSucursal}/SobreNosotros`) {
            return currentPath === path;
        }
        // Resaltar "Preguntas Frecuentes" para esa URL específica
        if (path === `/${idSucursal}/PreguntaFrecuentes`) {
            return currentPath === path;
        }
        // Resaltar "Catalogo" para esa URL específica
        if (path === `/${idSucursal}/Catalogo`) {
            return currentPath === path;
        }
        return false;
    };

    return (
        <div>
            <Navbar expand='lg' className="color-primary py-3">
                <Container fluid>
                    {/* Logo siempre visible */}
                    <Navbar.Brand as={Link} to={`/${idSucursal}`} className='d-lg-none text-start' style={{ marginLeft: '15px' }}>
                        <img
                            src={logo}
                            width='110'
                            alt='CrishaCaps'
                            title='CrishaCaps'
                            style={{ objectFit: 'cover' }}
                        />
                    </Navbar.Brand>
                    <div className='d-none d-lg-block position-absolute start-50 translate-middle-x'>
                        <Link as={Link} to={`/${idSucursal}`}>
                        <img
                            src={logo}
                            width='150'
                            alt='CrishaCaps'
                            title='CrishaCaps'
                            style={{ objectFit: 'cover' }}
                        />
                        </Link>
                        
                    </div>

                    {/* Navegación principal (pantallas grandes) */}
                    <Nav className='d-none d-lg-flex align-items-center'>
                        <Button
                            className={`nav-link text-light fw-semibold fs-6 ms-3 ${isActive(`/${idSucursal}`) ? 'active-nav-link' : ''}`}
                            onClick={redirectToRoot}
                        >
                            Inicio
                        </Button>

                        <Link to={`/${idSucursal}/Catalogo`} className='text-decoration-none ms-3'>
                            <Button className={`nav-link text-light fw-semibold fs-6 ${isActive(`/${idSucursal}/Catalogo`) ? 'active-nav-link' : ''
                                }`}>
                                Categorias
                            </Button>
                        </Link>

                        <Link to={`/${idSucursal}/PreguntaFrecuentes`} className='text-decoration-none ms-3'>
                            <Button className={`nav-link text-light fw-semibold fs-6 ${isActive(`/${idSucursal}/PreguntaFrecuentes`) ? 'active-nav-link' : ''
                                }`}>
                                Preguntas Frecuentes
                            </Button>
                        </Link>
                    </Nav>
                    <div className='d-flex align-items-center ms-auto'>
                        {/* Botón del menú toggle */}
                        <Button
                            variant='link'
                            onClick={toggleMenu}
                            aria-controls='offcanvasNavbar'
                            className='text-light me-2 d-lg-none'
                        >
                            <List size={24} />
                        </Button>

                        {/* Botones de carrito y "Grupo Mayorista" */}
                        <div className="d-flex align-items-center gap-2">
                            <button
                                onClick={showCar}
                                title='Carrito de compra'
                                className={`d-flex align-items-center button ${cartBounce ? 'cart-bounce' : ''}`}
                                style={{ marginLeft: '10px' }}
                            >
                                <span>{totalItems}</span>
                                <CartFill className="ms-1 d-lg-none" size={14} />
                                <CartFill className="ms-2 d-none d-lg-inline" size={20} />
                                <span className='d-none d-lg-inline fs-6'> Carrito</span>
                            </button>

                            <button
                                onClick={() => window.open(getWhatsappUrl(), '_blank')}
                                className="d-flex align-items-center position-relative d-none d-lg-inline button me-2"
                                aria-label="Unirse al grupo mayorista en WhatsApp"
                                title="Unirse al grupo mayorista en WhatsApp"
                            >
                                <Whatsapp size={20} className='d-none d-lg-inline' />
                                <span className='ms-0 ms-md-2'>Mayorista</span>
                            </button>
                        </div>
                    </div>

                </Container>
            </Navbar>

            <Offcanvas show={menuOpen} onHide={toggleMenu} placement="start" style={{ backgroundColor: '#2b235e' }}>
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title className="text-light">Menú</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <Link to="/" className="text-decoration-none">
                            <Button
                                className="nav-link text-light fw-semibold fs-6 text-start w-100"
                                onClick={redirectToRoot}
                            >
                                Inicio
                            </Button>
                        </Link>

                        <Link to="/Catalogo" className="text-decoration-none">
                            <Button className="nav-link text-light fw-semibold fs-6 text-start w-100">
                                Categorias
                            </Button>
                        </Link>

                        <Link to="/SobreNosotros" className="text-decoration-none">
                            <Button className="nav-link text-light fw-semibold fs-6 text-start w-100">
                                Sobre Nosotros
                            </Button>
                        </Link>

                        <Link to="/PreguntaFrecuentes" className="text-decoration-none">
                            <Button className="nav-link text-light fw-semibold fs-6 text-start w-100">
                                Preguntas Frecuentes
                            </Button>
                        </Link>
                    </Nav>

                    {/* Línea divisoria */}
                    <hr className="bg-light my-4" />

                    {/* Íconos de redes sociales */}
                    <div className="d-flex justify-content-around">
                        {socialLinks.map((link, index) => (
                            <a
                                key={index}
                                href={link.url}
                                rel='noreferrer noopener'
                                title={link.title}
                            >
                                <Button variant="link" className="text-danger">
                                    {getIcon(link.url)}
                                </Button>
                            </a>
                        ))}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Carrito component */}
            <CarUni show={show} handleClose={closeCar} />
        </div>
    );
}

export default NavbarUni;
